import { useIntl } from 'react-intl';
import { PageHead } from '../../components/common/head/page-head';
import { Navbar } from '../../components/common/navbar/navbar';
import { useSiteData } from '../../context/site-data-context';

export default function AreeDiMercato() {
  const { serviceCategories, technologyCategories } = useSiteData();
  const intl = useIntl();

  return (
    <>
      <PageHead
        title={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - An IBM company - Aree di mercato',
          description: 'Aree di mercato - Page title'
        })}
        description={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - Aree di mercato',
          description: 'Aree di mercato - Page description'
        })}
      />
      <Navbar
        navCssClasses="snf-bg-color-prussian-blue"
        serviceCategories={serviceCategories}
        technologyCategories={technologyCategories}
      />
      <main className="container" role="main" />
    </>
  );
}
